import { Box, Button, Stack, Typography } from "@mui/material";
import React, { useState } from "react";

import { JobBoradProps } from "../../interface/job_board";
import JobBoardTable from "./JobTable";
import { Pagination } from "../Pagination";
import JobStats from "./JobStats";
import { FilterJobsInputs } from "../FilterInputs";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

const JobBoardContent = ({
  jobData,
  stats,
  isLoading,
  paginationState,
  setPaginationState,
  setFilterData,
}: JobBoradProps) => {
  const [compare, setCompare] = useState(false);
  return (
    <Stack
      direction="column"
      justifyContent={"space-between"}
      sx={{ padding: 2, marginTop: 70, minHeight: "70vh" }}
    >
      <Stack>
        <JobStats stats={stats} />
        <Box sx={{ m: 2 }}>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            sx={{ mb: 1 }}
          >
            <Typography
              variant="subtitle2"
              color={"neutral"}
              sx={{ fontWeight: 700, fontFamily: "Inter" }}
            >
              Job Posting
            </Typography>
            <Button onClick={() => setCompare(!compare)}>
              {compare ? <FilterAltOffIcon /> : <FilterAltIcon />}
            </Button>
          </Stack>
          <Box
            sx={{
              width: "96%",
              background: "white",
              p: 3,
              mx: "auto",
              boxShadow:
                "0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
            }}
          >
            {compare && (
              <FilterJobsInputs
                loading={isLoading}
                setFilterData={setFilterData}
              />
            )}
            <JobBoardTable data={jobData} loading={isLoading} />
          </Box>
        </Box>
      </Stack>
      <Pagination
        paginationState={paginationState}
        setPaginationState={setPaginationState}
      />
    </Stack>
  );
};

export default JobBoardContent;
